import * as React from 'react';
import { connect } from 'react-redux';
import {
  extractSearch,
  getExtractTypes,
  regenerateExtract,
  generateExtract,
  viewData,
} from './redux-objects/actions';
import DataTable from '../DataTable';
import { IExtract, IExtractType, IStandardSummaryDatabase } from '../../common/sharedTypes';
import ReactDOM from 'react-dom';
import { Modal, Button } from 'react-bootstrap';
import moment from 'moment';
import * as urls from '../shared/urls';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import { DateRangePicker } from 'react-dates';
import './assets/extracts.scss';
import { toast } from 'react-toastify';
import { ApiResponse } from 'apisauce';
import SelectList from '../RBSelectList/RBSelectList';
import { getStandardSummaryDatabases } from '../StandardSummary/redux-objects/actions';
import { confirm } from '../WorkflowQueues/Checkers/ConfirmationDialog';
import { deleteById } from '../../services/extractService';
import { isGranted, permissions } from '../../services/permissionChecker';
import { UserInfo } from '../Login/common/defaults';

const $ = require('jquery');
$.DataTable = require('datatables.net-bs4');

export interface IExtractsAdminStateProps {
  results: IExtract[];
  extractTypes: IExtractType[];
  standardSummaryDatabases: IStandardSummaryDatabase[];
  webServiceURL: string;
  currentUser: UserInfo;
}
export interface IExtractsAdminActionProps {
  extractSearch?: (url: string) => Promise<void>;
  getExtractTypes?: (url: string) => Promise<void>;
  getStandardSummaryDatabases?: (url: string) => Promise<void>;
  regenerateExtract?: (
    url: string,
    extractId: number,
    comment: string,
    sendToCarfax: boolean,
    sendToExperian: boolean,
    sendToTruckBus: boolean,
    sendToFarsNhtsa: boolean,
    sendToLawFirm: boolean,
    sendToNdotSftp: boolean,
  ) => Promise<ApiResponse<any>>;
  generateExtract?: (
    url: string,
    extractTypeId: number,
    comment: string,
    startDate: string,
    endDate: string,
    sendToCarfax: boolean,
    sendToExperian: boolean,
    sendToTruckBus: boolean,
    crashKey: string,
    sendToFarsNhtsa: boolean,
    sendToLawFirm: boolean,
    sendToNdotSftp: boolean,
    exportFormat: number,
    snapshotDatabaseId: number
  ) => Promise<ApiResponse<any>>;
  viewData?: (extractId: number) => Promise<void>;
}
interface IExtractsAdminProps
  extends IExtractsAdminStateProps,
  IExtractsAdminActionProps { }

const initialState = {
  startDate: moment(
    moment().startOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  endDate: moment(moment().endOf('month').format('DD/MM/YYYY'), 'DD/MM/YYYY'),
  focusedInput: null,
  runStartDate: moment(
    moment().startOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  runEndDate: moment(
    moment().endOf('month').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  runDateFocusedInput: null,
  showComment: false,
  comment: '',
  selectedExtractId: null,
  selectedExtractTypeId: null,
  regenerateSendCarfax: true,
  regenerateSendExperian: true,
  regenerateSendTruckBus: true,
  regenerateSendFars: true,
  regenerateSendLawFirm: true,
  regenerateSendNdotSftp: true,
  regenerateExtractSelectedExportFormat: 1,
  resend: false,
  regenerate: false,

  showNewExtract: false,
  newExtractComment: '',
  newExtractTypeId: -1,
  newExtractSubTypeId: 1,
  newExtractStartDate: moment(
    moment().startOf('day').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  newExtractEndDate: moment(
    moment().startOf('day').format('DD/MM/YYYY'),
    'DD/MM/YYYY'
  ),
  newExtractCrashKey: '',
  newExtractDateFocusedInput: null,
  newExtractSendCarfax: false,
  newExtractSendExperian: false,
  newExtractSendTruckBus: false,
  newExtractSendFars: false,
  newExtractSendLawFirm: false,
  newExtractSendNdotSftp: false,
  searchExtractTypeId: -1,
  searchCrashKey: '',
  generatingExtract: false,
  snapshotDatabaseId: 1,
  chknChooseDb: false
};
type IExtractAdminState = Readonly<typeof initialState>;
class ExtractsAdmin extends React.Component<
  IExtractsAdminProps,
  IExtractAdminState
> {
  public constructor(props: IExtractsAdminProps) {
    super(props);
    this.state = initialState;
  }

  componentDidMount() {
    if (!this.props.extractTypes || this.props.extractTypes.length == 0) {
      var url = urls.GET_EXTRACT_TYPES;
      this.props.getExtractTypes(url);
    }
    if (!this.props.standardSummaryDatabases || this.props.standardSummaryDatabases.length == 0) {
      var url = urls.GET_STANDARD_SUMMARY_DATABASES;
      this.props.getStandardSummaryDatabases(url);
    }
  }
  doSearch() {
    let uri = this.props.webServiceURL + urls.EXTRACTS_SEARCH;

    var params = {
      startDate: this.state.startDate.toDate().toUTCString(),
      endDate: this.state.endDate.toDate().toUTCString(),
      runStartDate: this.state.runStartDate.toDate().toUTCString(),
      runEndDate: this.state.runEndDate.toDate().toUTCString(),
      crashKey: this.state.searchCrashKey,
      extractTypeId: this.state.searchExtractTypeId,
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + '=' + esc(params[k]))
      .join('&');

    uri = uri + '?' + query;
    this.props.extractSearch(uri);
  }
  handleSearchButton(event: React.MouseEvent<HTMLElement>) {
    this.doSearch();
  }

  handleNewExtractButton(event: React.MouseEvent<HTMLElement>) {
    this.setState({ showNewExtract: true });
  }

  onCloseCommentModal = () => {
    this.setState({
      showComment: false,
      selectedExtractId: null,
      selectedExtractTypeId: null,
      regenerate: false,
      resend: false,
    });
  };

  onCloseNewExtractModal = () => {
    this.setState({ showNewExtract: false });
  };

  onCreateNewExtract() {
    const url = urls.GENERATE_AND_SEND_EXTRACT;
    this.setState({ generatingExtract: true }, () => {
      this.props
        .generateExtract(
          url,
          this.state.newExtractTypeId,
          this.state.newExtractComment,
          this.state.newExtractStartDate.toDate().toUTCString(),
          this.state.newExtractEndDate.toDate().toUTCString(),
          this.state.newExtractSendCarfax,
          this.state.newExtractSendExperian,
          this.state.newExtractSendTruckBus,
          this.state.newExtractCrashKey,
          this.state.newExtractSendFars,
          this.state.newExtractSendLawFirm,
          this.state.newExtractSendNdotSftp,
          this.state.newExtractSubTypeId,
          this.state.snapshotDatabaseId
        )
        .then((result) => {
          if (result.status == 200) {
            toast.success('Extract Created');
          } else {
            toast.error('Error');
          }
        })
        .finally(() => {
          this.setState({
            showNewExtract: false,
            newExtractComment: '',
            generatingExtract: false,
          });
        });
    });
  }

  onExtractAction() {
    if (this.state.regenerate) var url = urls.REGENERATE_EXTRACT;
    else if (this.state.resend) var url = urls.RESEND_EXTRACT;
    else return;
    this.setState({ generatingExtract: true }, () => {
      this.props
        .regenerateExtract(
          url,
          this.state.selectedExtractId,
          this.state.comment,
          this.state.regenerateSendCarfax,
          this.state.regenerateSendExperian,
          this.state.regenerateSendTruckBus,
          this.state.regenerateSendFars,
          this.state.regenerateSendLawFirm,
          this.state.regenerateSendNdotSftp,
        )
        .then((result) => {
          if (result.status == 200) {
            toast.success(this.state.regenerate ? 'Regenerated' : 'Re-Sent');
          } else {
            toast.error('Error');
          }
        })
        .finally(() => {
          this.setState({
            showComment: false,
            regenerate: false,
            resend: false,
            generatingExtract: false,
          });
        });
    });
  }

  handleChange = (e: React.FormEvent) => {
    let el: HTMLFormElement = e.currentTarget as HTMLFormElement;

    switch (el.dataset.field) {
      case 'comment':
        this.setState({
          comment: el.value,
        });
        break;
      case 'regenerateSendExperian':
        this.setState({
          regenerateSendExperian: el.checked,
        });
        break;
      case 'regenerateSendCarfax':
        this.setState({
          regenerateSendCarfax: el.checked,
        });
        break;
      case 'newExtractComment':
        this.setState({
          newExtractComment: el.value,
        });
        break;
      case 'regenerateSendTruckBus':
        this.setState({
          regenerateSendTruckBus: el.checked,
        });
        break;
      case 'regenerateSendFars':
        this.setState({
          regenerateSendFars: el.checked,
        });
        break;
      case 'regenerateSendLawFirm':
        this.setState({
          regenerateSendLawFirm: el.checked,
        });
        break;
      case 'newExtractSendExperian':
        this.setState({
          newExtractSendExperian: el.checked,
        });
        break;
      case 'newExtractSendCarfax':
        this.setState({
          newExtractSendCarfax: el.checked,
        });
        break;
      case 'newExtractSendTruckBus':
        this.setState({
          newExtractSendTruckBus: el.checked,
        });
        break;
      case 'newExtractSendFars':
        this.setState({
          newExtractSendFars: el.checked,
        });
        break;
      case 'newExtractSendLawFirm':
        this.setState({
          newExtractSendLawFirm: el.checked,
        });
        break;
      case 'newExtractSendNdotSftp':
        this.setState({
          newExtractSendNdotSftp: el.checked,
        });
        break;
      case 'newExtractCrashKey':
        this.setState({
          newExtractCrashKey: el.value,
        });
        break;
      case 'extractType':
        this.setState({
          newExtractTypeId: el.value,
        });
        break;
      case 'extractSubType':
        this.setState({
          newExtractSubTypeId: el.value,
        });
        break;
      case 'searchExtractType':
        this.setState({
          searchExtractTypeId: el.value,
        });
        break;
      case 'searchCrashKey':
        this.setState({
          searchCrashKey: el.value,
        });
        break;
      case 'snapshotDatabase':
        this.setState({
          snapshotDatabaseId: el.value,
        });
        break;
      case 'chknChooseDb':
        var dbValue = el.checked ? this.state.snapshotDatabaseId : 1;
        this.setState({
          chknChooseDb: el.checked,
          snapshotDatabaseId: dbValue
        });
        break;
      default:
        break;
    }
  };

  handleDatesChanged(startDate, endDate) {
    if (startDate && endDate) {
      this.setState({ startDate, endDate });
    }
  }

  handleRunDatesChanged(runStartDate, runEndDate) {
    if (runStartDate && runEndDate) {
      this.setState({ runStartDate, runEndDate });
    }
  }

  handleNewExtractDatesChanged(newExtractStartDate, newExtractEndDate) {
    if (newExtractStartDate && newExtractEndDate) {
      this.setState({ newExtractStartDate, newExtractEndDate });
    }
  }

  handleViewData(event: React.MouseEvent<HTMLElement>, row: IExtract) {
    // let blob = new Blob([row.data], { type: 'text/xml' });
    // let url = URL.createObjectURL(blob);
    // window.open(url);
    // URL.revokeObjectURL(url); //Releases the resources

    viewData(row.id);
  }

  handleRegenerate(event: React.MouseEvent<HTMLElement>, row: any) {
    console.log('regenerate', row);
    this.setState({
      selectedExtractId: row.id,
      selectedExtractTypeId: row.extractTypeId,
      showComment: true,
      regenerate: true,
    });
  }

  handleResend(event: React.MouseEvent<HTMLElement>, row: any) {
    this.setState({
      selectedExtractId: row.id,
      selectedExtractTypeId: row.extractTypeId,
      showComment: true,
      resend: true,
    });
  }

  async handleDelete(cellData, rowData) {
    const confirmationResult = await confirm("Are you sure you want to delete extract?", {
      cancelText: 'Cancel',
      noText: 'No',
      yesText: 'Yes',
    });

    console.log({ cellData, rowData });
    switch (confirmationResult) {
      case 'yes':
        const response = await deleteById(cellData);
        if (!response.ok) {
          toast.error((response.data as any)?.Message);
        }
        this.doSearch();
        break;
      case 'no':
      case 'cancel':
      default:
        break;
    }
  }

  handleViewLogs(event: React.MouseEvent<HTMLElement>, rowData: any, td: any) {
    var table = $('#tblExtractResults').DataTable();
    var tr = $(td).closest('tr');
    var row = table.row(tr);

    if (row.child.isShown()) {
      row.child.hide();
      tr.removeClass('shown');
    } else {
      var childrow = this.createSubTable(rowData);
      row.child('<div id="divSubTable' + rowData.id + '"><div>').show();
      var divSubTable = $('#divSubTable' + rowData.id).get();
      ReactDOM.render(childrow, divSubTable[0]);
    }
  }

  createSubTable = (d?: IExtract) => {
    const subTable = (
      <React.Fragment>
        <table>
          <thead>
            <tr>
              <th>Log Date</th>
              <th>Data Generated</th>
              {d.extractTypeId == 1 && <th>Sent to Carfax</th>}
              {d.extractTypeId == 1 && <th>Sent to Experian</th>}
              {d.extractTypeId == 2 && <th>Sent to SFTP</th>}
              {d.extractTypeId == 3 && <th>Sent to Nhtsa</th>}
              {d.extractTypeId == 4 && <th>Sent to Law Firm</th>}
              <th>Comment</th>
              <th>Error</th>
            </tr>
          </thead>
          <tbody>
            {d.extractLogs &&
              d.extractLogs.length > 0 &&
              d.extractLogs
                .sort((a, b) => {
                  return (
                    new Date(b.createdDate).getTime() -
                    new Date(a.createdDate).getTime()
                  );
                })
                .map((x) => {
                  return (
                    <tr key={x.id}>
                      <td>
                        {moment(x.createdDate).format('MM/DD/YYYY hh:mm a')}
                      </td>
                      <td>
                        {x.dataGeneratedDate &&
                          moment(x.dataGeneratedDate).format(
                            'MM/DD/YYYY hh:mm a'
                          )}
                      </td>
                      {d.extractTypeId == 1 && (
                        <td>
                          {x.sentToCarfaxDate &&
                            moment(x.sentToCarfaxDate).format(
                              'MM/DD/YYYY hh:mm a'
                            )}
                        </td>
                      )}
                      {d.extractTypeId == 1 && (
                        <td>
                          {x.sentToExperianDate &&
                            moment(x.sentToExperianDate).format(
                              'MM/DD/YYYY hh:mm a'
                            )}
                        </td>
                      )}
                      {d.extractTypeId == 2 && (
                        <td>
                          {x.sentToTruckBusDate &&
                            moment(x.sentToTruckBusDate).format(
                              'MM/DD/YYYY hh:mm a'
                            )}
                        </td>
                      )}
                      {d.extractTypeId == 3 && (
                        <td>
                          {x.sentToNhtsa &&
                            moment(x.sentToNhtsa).format('MM/DD/YYYY hh:mm a')}
                        </td>
                      )}
                      {d.extractTypeId == 4 && (
                        <td>
                          {x.sentToLawFirm &&
                            moment(x.sentToLawFirm).format(
                              'MM/DD/YYYY hh:mm a'
                            )}
                        </td>
                      )}
                      <td>{x.comment}</td>
                      <td>{x.errorMessage}</td>
                    </tr>
                  );
                })}
          </tbody>
        </table>
      </React.Fragment>
    );
    return subTable;
  };

  public render() {
    const columnDefs = [
      {
        targets: 0,
        width: '200px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleViewData(cellData, rowData)}
              >
                <i className='fas fa-external-link-alt'></i> View Data
              </Button>
              {'  '}
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleViewLogs(cellData, rowData, td)}
              >
                <i className='far fa-eye'></i> View Logs
              </Button>
            </div>,
            td
          ),
      },
      {
        targets: 1,
        width: '200px',
        createdCell: (td, cellData, rowData, row, col) =>
          ReactDOM.render(
            <div>
              <Button
                variant='outline-primary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleRegenerate(cellData, rowData)}
              >
                {' '}
                <i className='fas fa-redo-alt'></i> Regenerate
              </Button>
              {'  '}
              <Button
                variant='outline-secondary'
                size='sm'
                data-id={cellData}
                onClick={(e) => this.handleResend(cellData, rowData)}
              >
                <i className='fas fa-file-import'></i> Re-send
              </Button>
              {(isGranted(permissions.ExtractsDeleteAny, this.props.currentUser) || (isGranted(permissions.ExtractsDeleteOwn, this.props.currentUser) && rowData.createdBy === this.props.currentUser?.id)) &&
                <Button
                  variant='outline-danger'
                  size='sm'
                  data-id={cellData}
                  onClick={() => this.handleDelete(cellData, rowData)}
                  className='ml-1'
                >
                  <i className='fas fa-trash'></i> Delete
                </Button>
              }
            </div>,
            td
          ),
      },
      {
        targets: 2,
        render: function (data) {
          return moment(data).format('MM/DD/YYYY hh:mm a'); // ('MMMM Do YYYY');
        },
      },
    ];

    const columns = [
      {
        title: 'View',
        data: 'id',
      },
      {
        title: 'Act',
        data: 'id',
      },
      {
        title: 'Created Date',
        data: 'createdDate',
      },
      {
        title: 'Run For Dates',
        mData: function (data, type, dataToSet) {
          if (
            moment(data.startDate).format('MM/DD/YYYY') ==
            moment(data.endDate).format('MM/DD/YYYY')
          ) {
            return moment(data.startDate).format('MM/DD/YYYY');
          }
          return (
            moment(data.startDate).format('MM/DD/YYYY') +
            ' - ' +
            moment(data.endDate).format('MM/DD/YYYY')
          );
        },
      },
      {
        title: 'Extract Type',
        mData: function (data, type, dataToSet) {
          let display = data.extractType.name;
          if (data.extractSubType && data.extractSubType.description) {
            display = display + ' - ' + data.extractSubType.description;
          }
          if (data.selectedDatabase && data.selectedDatabase.name && data.selectedDatabase.name != "Live") {
            display = display + ' - with DB: ' + data.selectedDatabase.name;
          }
          return display;
        },
      },
      {
        title: 'Status',
        mData: function (data, type, dataToSet) {
          if (data.isComplete) {
            return 'Complete';
          } else {
            return 'Incomplete!';
          }
        },
      },
    ];

    const options = {
      dom: 'frtipB',
    };
    console.log({ currentUser: this.props.currentUser });

    return (
      <React.Fragment>
        <div className="app extracts">
          <div className="row">
            <div className="col-sm-6">
              <h3>Extracts</h3>
            </div>
          </div>
          <Form>
            <Form.Row>
              <Form.Group as={Col} controlId="createdDates">
                <Form.Label>Extract Created Date</Form.Label>
                <br />
                <DateRangePicker
                  startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                  startDateId="extractCreatedSearchsStartDate" // PropTypes.string.isRequired,
                  endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                  endDateId="extractCreatedSearchsEndDate" // PropTypes.string.isRequired,
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleDatesChanged(startDate, endDate)
                  } // PropTypes.func.isRequired,
                  focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={(focusedInput) =>
                    this.setState({ focusedInput })
                  } // PropTypes.func.isRequired,
                  isOutsideRange={() => false}
                  small={true}
                  block={false}
                  minimumNights={0}
                />
              </Form.Group>
              <Form.Group as={Col} controlId="runDates">
                <Form.Label>Run For Dates</Form.Label>
                <br />
                <DateRangePicker
                  startDate={this.state.runStartDate} // momentPropTypes.momentObj or null,
                  startDateId="extractRunSearchsStartDate" // PropTypes.string.isRequired,
                  endDate={this.state.runEndDate} // momentPropTypes.momentObj or null,
                  endDateId="extractRunSearchsEndDate" // PropTypes.string.isRequired,
                  onDatesChange={({ startDate, endDate }) =>
                    this.handleRunDatesChanged(startDate, endDate)
                  } // PropTypes.func.isRequired,
                  focusedInput={this.state.runDateFocusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                  onFocusChange={(runDateFocusedInput) =>
                    this.setState({ runDateFocusedInput })
                  } // PropTypes.func.isRequired,
                  isOutsideRange={() => false}
                  small={true}
                  block={false}
                  minimumNights={0}
                />
              </Form.Group>
              <Form.Group controlId="exSType" as={Col}>
                <Form.Label>Extract Type</Form.Label>
                {this.props.extractTypes && this.props.extractTypes.length > 0 && (
                  <SelectList
                    data={
                      this.props.extractTypes &&
                      this.props.extractTypes.length > 0 &&
                      this.props.extractTypes.map((x) => {
                        return { name: x.name, value: x.id };
                      })
                    }
                    onChange={this.handleChange}
                    datafield="searchExtractType"
                    value={this.state.searchExtractTypeId.toString()}
                    placeholder="All Extracts"
                  />
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="searchCrashKey">
                <Form.Label>Crash Key</Form.Label>
                <Form.Control
                  type="text"
                  data-field="searchCrashKey"
                  value={this.state.searchCrashKey}
                  onChange={this.handleChange}
                />
              </Form.Group>
              <Form.Group as={Col}></Form.Group>
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} controlId="searchButton">
                <br />
                <Button
                  variant="primary"
                  onClick={(e) => this.handleSearchButton(e)}
                >
                  <i className="fas fa-search"></i> Search
                </Button>
                {"  "}
                <Button
                  variant="secondary"
                  onClick={(e) => this.handleNewExtractButton(e)}
                >
                  <i className="far fa-plus-square"></i> New Extract
                </Button>
              </Form.Group>
            </Form.Row>
            <Form.Row />
          </Form>

          {this.props.results && this.props.results.length > 0 && (
            <DataTable
              id="tblExtractResults"
              data={this.props.results.sort((a, b) => {
                return (
                  new Date(b.createdDate).getTime() -
                  new Date(a.createdDate).getTime()
                );
              })}
              columns={columns}
              columnDefs={columnDefs}
              actionsColumn="first"
              select={false}
              order={[[2, "desc"]]}
              {...options}
            />
          )}
        </div>

        <Modal show={this.state.showComment} onHide={this.onCloseCommentModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              Comment for{" "}
              {this.state.regenerate
                ? "Regenerate"
                : this.state.resend
                  ? "Re-send"
                  : ""}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form>
                <Form.Group controlId="Comment">
                  <Form.Label>
                    <strong>Comment</strong>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    data-field="comment"
                    placeholder="Enter comment"
                    onChange={this.handleChange}
                    value={this.state.comment}
                  />
                </Form.Group>
                {this.state.selectedExtractTypeId == 1 && (
                  <Form.Group controlId="chkCarfax">
                    <Form.Check
                      type="checkbox"
                      data-field="regenerateSendCarfax"
                      label=" Send to Carfax"
                      checked={this.state.regenerateSendCarfax}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.selectedExtractTypeId == 1 && (
                  <Form.Group controlId="chkExperian">
                    <Form.Check
                      type="checkbox"
                      data-field="regenerateSendExperian"
                      label=" Send to Experian"
                      checked={this.state.regenerateSendExperian}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.selectedExtractTypeId == 2 && (
                  <Form.Group controlId="chkTruckBusResend">
                    <Form.Check
                      type="checkbox"
                      data-field="regenerateSendTruckBus"
                      label=" Send to SFTP"
                      checked={this.state.regenerateSendTruckBus}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.selectedExtractTypeId == 3 && (
                  <Form.Group controlId="chkregenerateSendFars">
                    <Form.Check
                      type="checkbox"
                      data-field="regenerateSendFars"
                      label=" Send to NHTSA"
                      checked={this.state.regenerateSendFars}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.selectedExtractTypeId == 4 && (
                  <Form.Group controlId="chkregenerateSendLawFirm">
                    <Form.Check
                      type="checkbox"
                      data-field="regenerateSendLawFirm"
                      label=" Send to Law Firm"
                      checked={this.state.regenerateSendLawFirm}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.generatingExtract && (
              <div>
                Working {"   "}
                <img
                  src={require("../../../src/assets/SmartAdmin/img/32/Marty.gif")}
                />
              </div>
            )}
            <Button
              variant="danger"
              onClick={this.onCloseCommentModal}
              disabled={this.state.generatingExtract}
            >
              Cancel Action
            </Button>
            <Button
              variant="success"
              onClick={(e) => this.onExtractAction()}
              disabled={
                this.state.generatingExtract || this.state.comment.length == 0
              }
            >
              {this.state.regenerate
                ? "Regenerate"
                : this.state.resend
                  ? "Re-send"
                  : ""}
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showNewExtract}
          onHide={this.onCloseNewExtractModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>New Extract</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <Form>
                <Form.Group controlId="exType">
                  <Form.Label>
                    <strong>Extract Type</strong>
                  </Form.Label>
                  {this.props.extractTypes &&
                    this.props.extractTypes.length > 0 && (
                      <SelectList
                        data={
                          this.props.extractTypes &&
                          this.props.extractTypes.length > 0 &&
                          this.props.extractTypes.map((x) => {
                            return { name: x.name, value: x.id };
                          })
                        }
                        onChange={this.handleChange}
                        datafield="extractType"
                        value={this.state.newExtractTypeId.toString()}
                        placeholder="Select an Extract Type"
                      />
                    )}
                </Form.Group>


                {this.state.newExtractTypeId > -1 &&
                  this.props.extractTypes &&
                  this.props.extractTypes.length > 0 &&
                  this.props.extractTypes.filter(x => x.id == this.state.newExtractTypeId)[0].extractSubTypes != null
                  && this.props.extractTypes.filter(x => x.id == this.state.newExtractTypeId)[0].extractSubTypes.length > 0 && (
                    <Form.Group controlId="exSubType">
                      <Form.Label>
                        <strong>Extract Format</strong>
                      </Form.Label>
                      {this.props.extractTypes &&
                        this.props.extractTypes.length > 0 && (
                          <SelectList
                            data={
                              this.props.extractTypes.filter(x => x.id == this.state.newExtractTypeId)[0].extractSubTypes.map((x) => {
                                return { name: x.name, value: x.id };
                              })
                            }
                            onChange={this.handleChange}
                            datafield="extractSubType"
                            value={this.state.newExtractSubTypeId.toString()}
                          />
                        )}
                    </Form.Group>
                  )}

                {this.state.newExtractTypeId == 5 && (
                  <Form.Group controlId="chknChooseDb">
                    <Form.Check
                      type="checkbox"
                      data-field="chknChooseDb"
                      label=" Use Snapshot Database"
                      checked={this.state.chknChooseDb}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}

                {this.state.newExtractTypeId == 5 &&
                  this.state.chknChooseDb &&
                  this.props.standardSummaryDatabases && this.props.standardSummaryDatabases.length > 0 && (
                    <Form.Group controlId='ssDbs'>
                      <Form.Label><strong>Database</strong></Form.Label>
                      {this.props.standardSummaryDatabases && this.props.standardSummaryDatabases.length > 0 && (
                        <SelectList
                          data={
                            this.props.standardSummaryDatabases &&
                            this.props.standardSummaryDatabases.length > 0 &&
                            this.props.standardSummaryDatabases.map((x) => {
                              return { name: x.name, value: x.id };
                            })
                          }
                          onChange={this.handleChange}
                          datafield='snapshotDatabase'
                          value={this.state.snapshotDatabaseId.toString()}
                          placeholder='All Databases'
                        />
                      )}
                    </Form.Group>
                  )}

                {(this.state.newExtractTypeId == 1 ||
                  this.state.newExtractTypeId == 2 ||
                  this.state.newExtractTypeId == 5 ||
                  this.state.newExtractTypeId == 6) && (
                    <Form.Group controlId="newDates">
                      <Form.Label>Run For Dates</Form.Label>
                      <br />
                      <DateRangePicker
                        startDate={this.state.newExtractStartDate} // momentPropTypes.momentObj or null,
                        startDateId="newExtractStartDate" // PropTypes.string.isRequired,
                        endDate={this.state.newExtractEndDate} // momentPropTypes.momentObj or null,
                        endDateId="newExtractEndDate" // PropTypes.string.isRequired,
                        onDatesChange={({ startDate, endDate }) =>
                          this.handleNewExtractDatesChanged(startDate, endDate)
                        } // PropTypes.func.isRequired,
                        focusedInput={this.state.newExtractDateFocusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                        onFocusChange={(newExtractDateFocusedInput) =>
                          this.setState({ newExtractDateFocusedInput })
                        } // PropTypes.func.isRequired,
                        isOutsideRange={() => false}
                        small={true}
                        block={false}
                        minimumNights={0}
                      />
                    </Form.Group>
                  )}

                {(this.state.newExtractTypeId == 3 ||
                  this.state.newExtractTypeId == 4) && (
                    <Form.Group controlId="nCrashKey">
                      <Form.Label>
                        <strong>Crash Key</strong>
                      </Form.Label>
                      <Form.Control
                        data-field="newExtractCrashKey"
                        placeholder="Enter CrashKey"
                        onChange={this.handleChange}
                        value={this.state.newExtractCrashKey}
                      />
                    </Form.Group>
                  )}

                <Form.Group controlId="nComment">
                  <Form.Label>
                    <strong>Comment</strong>
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    data-field="newExtractComment"
                    placeholder="Enter comment"
                    onChange={this.handleChange}
                    value={this.state.newExtractComment}
                  />
                </Form.Group>
                {this.state.newExtractTypeId == 1 && (
                  <Form.Group controlId="chknCarfax">
                    <Form.Check
                      type="checkbox"
                      data-field="newExtractSendCarfax"
                      label=" Send to Carfax"
                      checked={this.state.newExtractSendCarfax}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.newExtractTypeId == 1 && (
                  <Form.Group controlId="chknExperian">
                    <Form.Check
                      type="checkbox"
                      data-field="newExtractSendExperian"
                      label=" Send to Experian"
                      checked={this.state.newExtractSendExperian}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.newExtractTypeId == 2 && (
                  <Form.Group controlId="chknTruckBus">
                    <Form.Check
                      type="checkbox"
                      data-field="newExtractSendTruckBus"
                      label=" Send file to sftp"
                      checked={this.state.newExtractSendTruckBus}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.newExtractTypeId == 3 && (
                  <Form.Group controlId="chkNewFars">
                    <Form.Check
                      type="checkbox"
                      data-field="newExtractSendFars"
                      label=" Send file to NHTSA"
                      checked={this.state.newExtractSendFars}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.newExtractTypeId == 4 && (
                  <Form.Group controlId="chkNewSendLawFirm">
                    <Form.Check
                      type="checkbox"
                      data-field="newExtractSendLawFirm"
                      label=" Send file to Law Firm"
                      checked={this.state.newExtractSendLawFirm}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
                {this.state.newExtractTypeId == 5 && (
                  <Form.Group controlId="chknewExtractSendNdotSftp">
                    <Form.Check
                      type="checkbox"
                      data-field="newExtractSendNdotSftp"
                      label=" Send file to Ndot SFTP"
                      checked={this.state.newExtractSendNdotSftp}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                )}
              </Form>
            </div>
          </Modal.Body>
          <Modal.Footer>
            {this.state.generatingExtract && (
              <div>
                Working{"   "}
                <img
                  src={require("../../../src/assets/SmartAdmin/img/32/Marty.gif")}
                />
              </div>
            )}
            <Button
              variant="danger"
              onClick={this.onCloseNewExtractModal}
              disabled={this.state.generatingExtract}
            >
              Cancel Action
            </Button>
            <Button
              variant="success"
              onClick={(e) => this.onCreateNewExtract()}
              disabled={
                this.state.generatingExtract ||
                this.state.newExtractComment.length == 0 ||
                (this.state.newExtractTypeId == 3 &&
                  (this.state.newExtractCrashKey || "").length == 0)
              }
            >
              Create
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export function mapStateToProps(state: any) {
  return {
    webServiceURL: state.Application.backendURL,
    results: state.Extracts.results,
    extractTypes: state.Extracts.extractTypes,
    elasticSearchURL: state.Application.elasticSearchURL,
    currentUser: state.Application.currentUser,
    standardSummaryDatabases: state.StandardSummary.standardSummaryDatabases,
  };
}

const mapDispatchToProps = {
  extractSearch,
  regenerateExtract,
  getExtractTypes,
  generateExtract,
  viewData,
  getStandardSummaryDatabases,
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtractsAdmin);
